import DonationListView from "../presentation/views/DonationListView.vue";
import DonationDetailView from "../presentation/views/DonationDetailView.vue";
import SubscriptionListView from "../presentation/views/SubscriptionListView.vue";
import SubscriptionDetailView from "../presentation/views/SubscriptionDetailView.vue";
import DonationModuleSettingsView from "../presentation/views/DonationModuleSettingsView.vue";
import TaxReceiptsPlaceholderView from "../presentation/views/TaxReceiptsPlaceholderView.vue";
import { TAX_RECEIPTS_TABS } from "../presentation/composables/taxReceiptsTabs";
import { DONATION_MODULE_SETTINGS_PATH, DONATION_MODULE_SETTINGS_ROUTE_NAME, } from "../presentation/composables/donationModuleSettingsTabs";
// Tax-receipts area: four flat routes sharing one header (TaxReceiptsPageHeader). Paths and
// names and capabilities come from the tab list, so the header tabs and the route table cannot
// drift; this map only adds the view, and a tab without an entry fails to compile. The screens
// not delivered yet render the placeholder view.
const TAX_RECEIPTS_SCREENS = {
    dashboard: { component: TaxReceiptsPlaceholderView },
    donation: { component: TaxReceiptsPlaceholderView },
    newBatch: { component: TaxReceiptsPlaceholderView },
    batchReport: { component: TaxReceiptsPlaceholderView },
};
const taxReceiptsRoutes = TAX_RECEIPTS_TABS.map((tab) => {
    const screen = TAX_RECEIPTS_SCREENS[tab.key];
    return {
        path: tab.path,
        name: tab.routeName,
        component: screen.component,
        meta: {
            requiresAuth: true,
            requiresCapability: tab.requiresCapability,
            titleKey: screen.titleKey ?? tab.labelKey,
        },
    };
});
export const financeRoutes = [
    {
        path: "/donations",
        name: "DonationList",
        component: DonationListView,
        meta: { requiresAuth: true, titleKey: "finance.donations.title" },
    },
    {
        path: "/donations/:donationId",
        name: "DonationDetail",
        component: DonationDetailView,
        meta: { requiresAuth: true, titleKey: "finance.donations.title" },
    },
    {
        path: "/subscriptions",
        name: "SubscriptionList",
        component: SubscriptionListView,
        meta: { requiresAuth: true, titleKey: "finance.subscriptions.title" },
    },
    {
        path: "/subscriptions/:subscriptionId",
        name: "SubscriptionDetail",
        component: SubscriptionDetailView,
        meta: { requiresAuth: true, titleKey: "finance.subscriptions.title" },
    },
    ...taxReceiptsRoutes,
    { path: "/tax-receipts/settings", redirect: { name: DONATION_MODULE_SETTINGS_ROUTE_NAME } },
    {
        // Settings › Module management › Finance; SettingsSidebar gates its entry on the same capability.
        path: DONATION_MODULE_SETTINGS_PATH,
        name: DONATION_MODULE_SETTINGS_ROUTE_NAME,
        component: DonationModuleSettingsView,
        meta: { requiresAuth: true, requiresCapability: "opdon.edit", titleKey: "finance.donationModuleSettings.title" },
    },
];
export const financeNavigationItems = [
    {
        labelKey: "finance.title",
        children: [
            {
                labelKey: "finance.donations.title",
                path: "/donations",
                meta: { requiresAuth: true },
            },
            {
                labelKey: "finance.subscriptions.title",
                path: "/subscriptions",
                meta: { requiresAuth: true },
            },
        ],
    },
];
